<template>
    <div @click="onClick" :class="{ disabled: props.disabled }" class="toggler">
        <button
            v-bind:class="{ checked: props.disabled ? props.checked : data.checked, inline: props.inline }"
            type="button"
            :title="props.name"
        >
            <span v-if="!props.inline">{{ props.name }}</span>
            <i></i>
            <span v-if="!props.inline">{{ props.name }}</span>
        </button>
        <span v-if="props.inline">{{ props.name }}</span>
    </div>
</template>
 
<script setup>
import { reactive, watch } from 'vue';

const props = defineProps({
    disabled: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    name: { type: String, default: '' }
});

const emit = defineEmits(['onClick']);

const data = reactive({
    checked: props.checked
});

const onClick = () => {
    if (props.disabled) {
        return;
    }
    data.checked = !data.checked;
    emit('onClick', {
        name: props.name,
        value: data.checked
    });
};

watch(
    () => props.checked,
    () => {
        data.checked = props.checked;
    },
    { deep: true }
);
</script>

<style lang="scss" scoped>
button {
    border: none;
    outline: none;
    height: 38px;
    padding: 4px 12px;
    gap: 0;
    border-radius: 20px;
    display: flex;
    font-variant: unset;
    transition: all 0.4s;
    align-items: center;
    justify-content: center;
    position: relative;
    background: var(--dark-20);
    transition: all 0.4s;
    transform: none;
    cursor: pointer;

    span {
        flex: 1 1;
        font: var(--font-caption);
        overflow: hidden;
        transition: all 0.4s;
        white-space: nowrap;
        &:first-child {
            flex: 0 1;
            color: var(--white-500);
            width: 0;
        }
        &:last-child {
            direction: rtl;
            color: var(--dark-500);
        }
    }

    i {
        width: 24px;
        height: 24px;
        background: var(--white-500);
        border-radius: 50%;
        margin-left: -6px;
        margin-right: 6px;
        transition: all 0.4s;
    }

    &.checked {
        background: var(--gradient-2);
        i {
            margin-left: 6px;
            margin-right: -6px;
        }
        span {
            flex: 1 1;
            width: auto;
            &:last-child {
                flex: 0 1;
                width: 0;
            }
        }
    }

    &[disabled] {
        background: var(--light-10);
        cursor: default;
    }

    &.inline {
        height: 22px;
        width: 38px;
        overflow: visible;
        border-radius: 20px;
        padding: 0 2px;
        flex-shrink: 0;

        i {
            width: 18px;
            height: 18px;
            margin: 0;
            position: absolute;
            left: 2px;
            top: 2px;
        }

        &.checked {
            i {
                left: calc(100% - 20px);
            }
        }
    }
    &.inline + span {
        font: var(--font-body-2);
        color: var(--dark-500);
    }

    &.inline.checked + span {
        // color: var(--primary-500);
    }
}

.direction-rtl button {
    &:not(.inline) {
        i {
            margin-left: 6px;
            margin-right: -6px;
        }

        &.checked {
            i {
                margin-left: -6px;
                margin-right: 6px;
            }
        }
    }

    &.inline {
        i {
            left: auto;
            right: 2px;
        }

        &.checked {
            i {
                right: calc(100% - 20px);
                left: auto;
            }
        }
    }
}


div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    span {
        cursor: pointer;
    }

    &.disabled {
        button {
            filter: grayscale(.6);
        }


        button.inline {
            & + span {
                color: var(--dark-20);
            }
        }

        span,
        button {
            cursor: default;
        }
    }

    &.reverse {
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    &.solid {
        .inline + span {
            font: var(--font-body-1);
            font-weight: bold;
            color: var(--dark-500);
        }
    }
}
</style>
